import { createFileRoute } from '@tanstack/react-router';

interface VerifySearchParams {
  vt?: string;
}

export const Route = createFileRoute('/verify/$uuid')({
  validateSearch: (search: Record<string, unknown>): VerifySearchParams => ({
    vt: typeof search.vt === 'string' ? search.vt : undefined,
  }),
});
